import { computed, Injectable, signal } from '@angular/core';

// Tracks full-page (fixed) spinners that are currently loading, so the page shell can
// hold back below-content chrome like the footer until the page has rendered (avoids CLS).
@Injectable({ providedIn: 'root' })
export class PageLoadingService {
  private readonly pending = signal(0);

  readonly isLoading = computed(() => this.pending() > 0);

  start(): void {
    this.pending.update(n => n + 1);
  }

  stop(): void {
    this.pending.update(n => Math.max(0, n - 1));
  }
}
